module.exports = __webpack_public_path__ + "static/ss2.7593db43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss2.png
// module id = 1163
// module chunks = 277036769636407